class TestimonialsCarousel {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.carousel = document.getElementById(`testimonials-${sectionId}`);
    if (!this.carousel) return;
    this.track = this.carousel.querySelector(".testimonials-track");
    this.cards = this.carousel.querySelectorAll(".testimonial-card");
    this.prevButton = this.carousel.querySelector(".nav-button.prev");
    this.nextButton = this.carousel.querySelector(".nav-button.next");
    this.dots = this.carousel.querySelectorAll(".dot");
    this.isAnimating = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.isSwiping = false;
    this.totalSlides = this.cards.length;
    this.currentSlide = Math.floor(this.totalSlides / 2);
    this.init();
  }
  init() {
    this.bindEvents();
    setTimeout(() => this.updateCarousel(false), 100);
  }
  updateCarousel(animate = true) {
    if (!this.cards[this.currentSlide]) return;
    const cardWidth = this.cards[0].offsetWidth;
    const gap = parseInt(getComputedStyle(this.track).gap) || 0;
    const containerWidth = this.carousel.offsetWidth;
    const cardPosition = (cardWidth + gap) * this.currentSlide;
    const centerOffset = containerWidth / 2 - cardWidth / 2;
    const newOffset = -(cardPosition - centerOffset);
    this.track.style.transition = animate ? "transform 0.35s ease" : "none";
    this.track.style.transform = `translateX(${newOffset}px)`;
    if (this.prevButton) {
      this.prevButton.disabled = this.currentSlide === 0;
      this.prevButton.style.opacity = this.currentSlide === 0 ? "0.35" : "1";
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.currentSlide === this.totalSlides - 1;
      this.nextButton.style.opacity = this.currentSlide === this.totalSlides - 1 ? "0.35" : "1";
    }
    this.dots.forEach((dot, index) => dot.classList.toggle("active", index === this.currentSlide));
  }
  goToSlide(index) {
    if (this.isAnimating || index < 0 || index >= this.totalSlides) return;
    this.isAnimating = true;
    this.currentSlide = index;
    this.updateCarousel(true);
    setTimeout(() => { this.isAnimating = false; }, 400);
  }
  bindEvents() {
    if (this.prevButton) this.prevButton.addEventListener("click", () => this.goToSlide(this.currentSlide - 1));
    if (this.nextButton) this.nextButton.addEventListener("click", () => this.goToSlide(this.currentSlide + 1));
    this.dots.forEach((dot, index) => dot.addEventListener("click", () => this.goToSlide(index)));
    this.bindTouchEvents();
    window.addEventListener("resize", () => setTimeout(() => this.updateCarousel(false), 50));
  }
  bindTouchEvents() {
    const onStart = (e) => { if (this.isAnimating) return; this.touchStartX = e.touches[0].clientX; this.touchStartY = e.touches[0].clientY; this.isSwiping = true; };
    const onMove = (e) => {
      if (!this.isSwiping) return;
      this.touchEndX = e.touches[0].clientX;
      this.touchEndY = e.touches[0].clientY;
      const dx = this.touchEndX - this.touchStartX;
      const dy = this.touchEndY - this.touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 20) e.preventDefault();
    };
    const onEnd = () => {
      if (!this.isSwiping || this.isAnimating) return;
      const dx = this.touchEndX - this.touchStartX;
      const dy = this.touchEndY - this.touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
        if (dx > 0) this.goToSlide(this.currentSlide - 1);
        else this.goToSlide(this.currentSlide + 1);
      }
      this.isSwiping = false;
    };
    this.track.addEventListener("touchstart", onStart, { passive: false });
    this.track.addEventListener("touchmove", onMove, { passive: false });
    this.track.addEventListener("touchend", onEnd, { passive: true });
  }
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="testimonials-"]').forEach((container) => {
    const sectionId = container.id.replace("testimonials-", "");
    new TestimonialsCarousel(sectionId);
  });
});